import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Partners as PartnersIcon } from "@dreamhub/designsystem/icons";
import PageLayout from "@/pages/settings/components/PageLayout";
import { PartnersSettingsTabs } from "@/pages/settings/types";
import { GeneralTab } from "@/pages/settings/components/partnersSettings/GeneralTab";
import { FieldManagementTab } from "@/pages/settings/components/partnersSettings/FieldManagementTab";

const TRANSLATION_KEY = "settings.partners";
const TRANSLATION_KEY_TABS = "settings.partners.tabs";

export const PartnersSettings: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [tabValue, setTabValue] = useState<PartnersSettingsTabs>(() => {
    const tabParam = searchParams.get("tab");
    return Object.values(PartnersSettingsTabs).includes(
      tabParam as PartnersSettingsTabs
    )
      ? (tabParam as PartnersSettingsTabs)
      : PartnersSettingsTabs.GENERAL;
  });

  useEffect(() => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("tab", tabValue);
      return params;
    });
  }, [tabValue, setSearchParams]);

  const getTabOptions = () => {
    const options: Record<string, string> = {};
    Object.values(PartnersSettingsTabs).forEach((tab) => {
      options[tab] = t(`${TRANSLATION_KEY_TABS}.${tab}`);
    });
    return options;
  };

  const renderTabContent = () => {
    switch (tabValue) {
      case PartnersSettingsTabs.GENERAL:
        return <GeneralTab />;
      case PartnersSettingsTabs.FIELD_MANAGEMENT:
        return <FieldManagementTab />;
      default:
        return <GeneralTab />;
    }
  };

  return (
    <PageLayout
      data-test="settings-partners-page"
      title={t(`${TRANSLATION_KEY}.title`)}
      logoIcon={<PartnersIcon />}
      tabs={{
        options: getTabOptions(),
        defaultValue: tabValue,
        valueSelected: (newTabValue: string) =>
          setTabValue(newTabValue as PartnersSettingsTabs)
      }}
    >
      {renderTabContent()}
    </PageLayout>
  );
};
